import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-leaderboard-bets-wrapper',
  templateUrl: './leaderboard-bets-wrapper.template.html',
  styleUrls: ['./leaderboard-bets-wrapper.styles.scss'],
})
export class LeaderboardBetsWrapperComponent {
  @Input() rows: number = 6;

  constructor() {}
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/games/shared/leaderboard-bets-wrapper/leaderboard-bets-wrapper.component.ts